import { BUILDER_LINKS, builderPrices } from '../data/builder'
import { variantIdOf } from '../data/productLinks'

/**
 * Add-ons that ride along with the pack a customer checks out on the offer cards:
 * RX Capability Inserts and Anti-Fog Care Kits, on a Complete System or any multipack.
 * Set right before routing; any upgrade accepted in a popup keeps them.
 */
let pendingRx = 0
let pendingCare = 0

export function rxInsertConnected(): boolean {
  return Boolean(variantIdOf(BUILDER_LINKS.rxInsert))
}

export function careKitConnected(): boolean {
  return Boolean(variantIdOf(BUILDER_LINKS.careKit))
}

export function setPendingRx(quantity: number) {
  pendingRx = rxInsertConnected() ? Math.max(0, Math.floor(quantity)) : 0
}

export function setPendingCare(quantity: number) {
  pendingCare = careKitConnected() ? Math.max(0, Math.floor(quantity)) : 0
}

/** Appends the pending add-on lines to a Shopify cart permalink and reports the extra value. */
export function applyCartAddons(href: string): { href: string; extraValue: number; rx: number; care: number } {
  const rxId = variantIdOf(BUILDER_LINKS.rxInsert)
  const careId = variantIdOf(BUILDER_LINKS.careKit)
  const rx = rxId ? pendingRx : 0
  const care = careId ? pendingCare : 0
  if (!href || (rx <= 0 && care <= 0)) return { href, extraValue: 0, rx: 0, care: 0 }

  const [path, query] = href.split('?')
  const params = new URLSearchParams(query ?? '')
  let lines = path
  if (rx > 0) {
    lines += `,${rxId}:${rx}`
    params.set('attributes[RX inserts]', String(rx))
  }
  if (care > 0) {
    lines += `,${careId}:${care}`
    params.set('attributes[Care kits]', String(care))
  }
  const extra = rx * builderPrices.rxInsert + care * builderPrices.careKit
  return {
    href: `${lines}?${params.toString()}`,
    extraValue: Math.round(extra * 100) / 100,
    rx,
    care,
  }
}
